"use client";
import { flowSpcice, gaCommonEvent } from "@/src/utils";
import { MARKETING_PAGES_LIST_COOKIE_NAME } from "@/config/constConf";
import {
    getCookieItem,
    getLocalItem,
    setCookieItem,
    setLocalItem,
    setSession,
} from "@/lib/commonService";
import { uniq } from "lodash";
import React, { useCallback, useEffect } from "react";
import { useSearchParams } from "next/navigation";
import criteoAd from "@/src/components/LoadAnalysis/analysis/criteo";
import { useCommonContext, useProductsContext } from "@/src/provider";
import { useTryonStore } from "@/store/modules/tryon";
import CompTryOn from "@/src/components/CompTryOn";
import { GoogleAnalytics } from "@/src/components/LoadAnalysis/utils";

interface InitOnClientProps {
    pageInfo: any;
}
// 澳洲站试用的页面的b模版flow
const trialPageFlowCode: Record<number, string> = {
    7952: "5E60EB44383C390F98FE7D42DCF0A8B1",
    7955: "705568A8BCDC3CBE981AA10FD70D44C8",
};

// 需要在客户端进行初始化的使用这个组件
const InitOnClient: React.FC<InitOnClientProps> = (props) => {
    // 流量归因参数，二次营销参数
    const { flow, is_secondary, page_id } = props.pageInfo;
    const searchParams = useSearchParams();
    const { site } = useCommonContext();
    const productsData = useProductsContext((state) => state.productData.data);
    function setMarketingPageCookie(id: number) {
        const list_str: string | undefined = getCookieItem(
            MARKETING_PAGES_LIST_COOKIE_NAME,
        );
        let _arr: string[] = list_str ? list_str.split(",") : [];
        _arr.push(`${id}`);
        _arr = uniq(_arr);
        setCookieItem(MARKETING_PAGES_LIST_COOKIE_NAME, _arr.join(","));
    }
    const closeTryOn = useTryonStore((state) => state.closeTryOn);

    const handleCloseTryOn = useCallback(() => {
        gaCommonEvent("try on use", {
            event_category: "try on",
        });
        closeTryOn();
    }, [closeTryOn]);
    useEffect(() => {
        // AB模版流量归因参数
        const flowCode = trialPageFlowCode[page_id];
        // 试用上线的两个专题页
        if (flowCode && site == "au") {
            if (!getLocalItem("flow1")) flowSpcice.init(true, flowCode);
            setLocalItem("flow1", flowCode);
        } else {
            if (flow && !getLocalItem("flow1")) {
                flowSpcice.init(true, flow);
            }
            flow && setLocalItem("flow1", flow);
        }

        // 二次营销参数
        if (is_secondary) {
            setMarketingPageCookie(page_id);
        }
        const shareCode = searchParams.get("code");
        if (shareCode) {
            setSession("shareCode", shareCode);
        }
        GoogleAnalytics(
            {
                ecomm_prodid: "",
                ecomm_pagetype: "category",
                ecomm_totalvalue: 0,
            },
            () => {},
        );

        gaCommonEvent("new_view_specsubs", {
            non_interaction: true,
        });
        setCookieItem("isOldSpecsubs", "0", { expires: 365 });
    }, [flow, is_secondary, page_id, searchParams, site]);

    useEffect(() => {
        if (productsData.length > 0) criteoAd.viewList({ data: productsData });
    }, [productsData]);

    return <CompTryOn onClose={handleCloseTryOn} />;
};

export default InitOnClient;
